// This is the runtime configuration file.  It complements the Gruntfile.js by
// supplementing shared properties.
require.config({
  paths: {
    vendor: '../vendor',
    almond: '../vendor/node_modules/almond/almond',
    requirejs: '../vendor/node_modules/requirejs/require',
    public: '../public',
    underscore: '../vendor/node_modules/lodash/dist/lodash.underscore',
    lodash: '../vendor/node_modules/lodash/dist/lodash',
    ldsh: '../vendor/node_modules/lodash-template-loader/loader',
    jquery: '../vendor/node_modules/jquery/dist/jquery',
    backbone: '../vendor/node_modules/backbone/backbone',
    lpg: 'common/lpg',
    i18n: '../vendor/node_modules/i18next-client/i18next.amd.withJQuery',
    ckeditor: '../vendor/node_modules/ckeditor/ckeditor',
    ckeditorJQuery: '../vendor/node_modules/ckeditor/adapters/jquery',
    highcharts: '../vendor/node_modules/highcharts-release/modules/exporting',
    'highcharts-theme': '../vendor/node_modules/highcharts-release/themes/grid-light',
    'highcharts-module': '../vendor/node_modules/highcharts-release/highcharts',
    'highcharts-funnel': '../vendor/node_modules/highcharts-release/modules/funnel',
    cm: '../vendor/node_modules/codemirror',
    codemirror: 'cm/lib/codemirror',
    'codemirror-htmlmixed': 'cm/mode/htmlmixed/htmlmixed',
    spectrum: '../vendor/node_modules/spectrum/spectrum',
    fineuploader: '../vendor/lib/jquery.fineuploader-5.0.3',
    env: 'environments/index',
    fontmanager: 'fonts/index',
    sinon: '../vendor/node_modules/sinon/pkg/sinon',
    specs: '../test/mocha/specs',
    marked: '../vendor/node_modules/marked/lib/marked',
    picker: '../vendor/node_modules/pickadate/lib/picker',
    datepicker: '../vendor/node_modules/pickadate/lib/picker.date',
    hopscotch: '../vendor/node_modules/hopscotch/dist/js/hopscotch',
    mdzendeskjs: '../vendor/node_modules/md-zendeskjs/dist/index.umd',
    react: '../vendor/node_modules/react/umd/react.production.min',
    'react-dom': '../vendor/node_modules/react-dom/umd/react-dom.production.min',
    'prop-types': '../vendor/node_modules/prop-types/prop-types.min',
    mdheaderjs: '../vendor/node_modules/md-headerjs/dist/index.umd',
    mdfooterjs: '../vendor/node_modules/md-footerjs/dist/index.umd',
    mdsidebarjs: '../vendor/node_modules/md-sidebarjs/dist/index.umd',
    mdremindersjs: '../vendor/node_modules/md-remindersjs/dist/index.umd',
    ServicesHelper: 'common/views/helpers/ServicesHelper',
    ThemesHelper: 'common/views/helpers/ThemesHelper',
    mdnotice: '../vendor/node_modules/md-noticejs/lib/mdnotice',
  },
  shim: {
    backbone: {
      deps: ['jquery', 'underscore'],
      exports: 'Backbone',
    },
    ckeditor: {
      deps: ['jquery'],
    },
    ckeditorJQuery: {
      deps: ['jquery', 'ckeditor'],
    },
    'highcharts-module': {
      // This allows users to only import highcharts
      exports: 'Highcharts', //   without theme or exporting module.
      deps: ['jquery'],
    }, // Make sure highcharts.js is loaded
    'highcharts-theme': ['highcharts-module'], //   before the theme is.
    highcharts: {
      deps: ['highcharts-module', 'highcharts-theme'],
      exports: 'Highcharts', // Still gotta make this available
    },
    'highcharts-funnel': {
      deps: ['highcharts-module'],
    },
    codemirror: {
      deps: ['codemirror-htmlmixed'],
      export: 'CodeMirror',
    },
    fineuploader: {
      deps: ['jquery'],
    },
    sinon: {
      exports: 'sinon',
    },
    marked: {
      exports: 'marked',
    },
    picker: {
      deps: ['jquery'],
    },
    datepicker: {
      deps: ['jquery', 'picker'],
    },
  },
});

define("config", function(){});

